import React from 'react';
import {observer} from 'mobx-react-lite';
import {reportGeneratorsStore} from './stores/ReportGeneratorsStore';
import {Analytics} from './Analytics';

export const AnalyticsProvider = observer(() => {
    const {currentScreen} = reportGeneratorsStore;
    return currentScreen?.isOpen ? <Analytics /> : null;
});
